import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Disclosure',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
